"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const monaco = __importStar(require("monaco-editor"));
const append_empty_line_1 = require("./append-empty-line");
const monaco_suggest_button_scss_1 = __importDefault(require("./styles/monaco-suggest-button.scss"));
let isFirstButton = true;
function showSuggestButtons(editor) {
    const model = editor.getModel();
    if (!model) {
        throw new Error('Cannot get model');
    }
    let previousLine = 0;
    let decorations = [];
    let handler = 0;
    const moveButton = (lineNumber) => {
        if (lineNumber === previousLine)
            return;
        if (!lineNumber) {
            if (decorations.length) {
                decorations = editor.deltaDecorations(decorations, []);
            }
            return;
        }
        window.cancelIdleCallback(handler);
        handler = window.requestIdleCallback(() => {
            decorations = editor.deltaDecorations(decorations, [
                {
                    range: new monaco.Range(lineNumber, 1, lineNumber, 1),
                    options: {
                        isWholeLine: true,
                        afterContentClassName: isFirstButton
                            ? monaco_suggest_button_scss_1.default.emphasized
                            : monaco_suggest_button_scss_1.default.line
                    }
                }
            ]);
            previousLine = lineNumber;
            isFirstButton = false;
        }, { timeout: 1000 });
    };
    editor.onDidChangeCursorPosition(e => {
        moveButton(e.position.lineNumber);
    });
    editor.setPosition(new monaco.Position(model.getLineCount(), 1));
    editor.onMouseDown(e => {
        const { element, position, type } = e.target;
        if (!position || !element)
            return;
        const isButtonClicked = type === monaco.editor.MouseTargetType.CONTENT_EMPTY &&
            (element.classList.contains(monaco_suggest_button_scss_1.default.line) ||
                element.classList.contains(monaco_suggest_button_scss_1.default.emphasized));
        const isEmptyLineClicked = type === monaco.editor.MouseTargetType.CONTENT_EMPTY &&
            position.column === 1;
        // If line is empty, "afterContentClassName" decoration won't given the button element
        // Avoid this problem, isEmptyLineClicked will be true when a line is empty
        if (!isButtonClicked && !isEmptyLineClicked)
            return;
        // Show suggestion
        let cursor = new monaco.Position(position.lineNumber, 1 + model.getLineLength(position.lineNumber));
        const content = model.getLineContent(cursor.lineNumber);
        if (!append_empty_line_1.isEmptyLine(content)) {
            const spaces = model
                .getFullModelRange()
                .containsPosition(new monaco.Position(cursor.lineNumber + 1, 1))
                ? Math.max(append_empty_line_1.indent(content), append_empty_line_1.indent(model.getLineContent(cursor.lineNumber + 1)))
                : append_empty_line_1.indent(content);
            // Add empty line
            const text = '\n' + ' '.repeat(spaces);
            model.pushEditOperations([], [
                {
                    range: monaco.Range.fromPositions(cursor),
                    text
                }
            ], () => null);
            cursor = new monaco.Position(cursor.lineNumber + 1, text.length);
        }
        moveButton();
        // Edit Operation が busy な時に setPosition すると
        // Operation が apply された後にカーソルが動いてしまうので
        // 少しディレイを置いてから setPosition/Show Suggestion する
        window.requestIdleCallback(() => {
            editor.setPosition(cursor);
            const suggest = editor.getAction('editor.action.triggerSuggest');
            suggest.run();
        }, { timeout: 1000 });
    });
}
exports.showSuggestButtons = showSuggestButtons;
